// Query keys in one place so optimistic updates and invalidations always
// address the same cache entries.

export const qk = {
  me: ['me'],
  authConfig: ['auth-config'],
  mcp: ['mcp'],
  systems: ['systems', 'list'],
  systemDetails: (slug) => ['systems', 'detail', slug],
  system: (slug, version = 'current') => ['systems', 'detail', slug, version],
  systemFile: (slug, version, path) => ['systems', 'file', slug, version, path],
  systemFiles: (slug) => ['systems', 'file', slug],
  versions: (slug) => ['systems', 'versions', slug],
  conversationLists: ['conversations', 'list'],
  conversationList: (filters) => ['conversations', 'list', filters],
  conversation: (id) => ['conversations', 'detail', id],
  widgets: (id) => ['conversations', 'widgets', id],
  share: (token) => ['shares', token],
  supportTickets: ['support', 'tickets'],
  projects: ['projects'],
  sybill: ['sybill'],
  transcript: (projectId, weekOf) => ['projects', 'transcript', projectId, weekOf],
  settings: ['settings'],
  users: ['users'],
}
